module.exports = __webpack_public_path__ + "img/38.2.TN.ada2b556.png";